// removed by extract-text-webpack-plugin
module.exports = {"container":"container-3u--A","modal":"modal-1bGaZ","input":"input-3wpry","labels":"labels-3TL06","number":"number-ky83u","right":"right-2MUzl","label":"label-EGMdY","button":"button-2sasM btn-3FsRe","button-input":"button-input-1hLR5","upload":"upload-1gPtB","doc":"doc-1YELE","btn":"btn-WUOqZ btn-3FsRe","prefix":"prefix-3sSwC","input-date":"input-date-2QGeC","label-date":"label-date-1H-56"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/auto-import/style.scss
 ** module id = 52
 ** module chunks = 0
 **/